import _regeneratorRuntime from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import $ from 'jquery';

var loadApp =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(name, namespaces) {
    var options,
        _ref2,
        _ref3,
        i18n,
        module,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _context.prev = 1;
            _context.next = 4;
            return Promise.all([import(
            /* webpackChunkName: "i18n" */
            '../i18n'), import(
            /* webpackChunkName: "[request]" */
            "./".concat(name))]);

          case 4:
            _ref2 = _context.sent;
            _ref3 = _slicedToArray(_ref2, 2);
            i18n = _ref3[0];
            module = _ref3[1];
            _context.next = 10;
            return i18n.default(_objectSpread({
              ns: namespaces
            }, options));

          case 10:
            module.default(i18n.i18next);
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.log("An error occurred while loading ".concat(name), _context.t0);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 13]]);
  }));

  return function loadApp(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/* eslint-disable no-unused-vars */


export default
/*#__PURE__*/
_asyncToGenerator(
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee2() {
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if ($('[data-sampleapp]').length) {
            loadApp('sampleapp', ['sampleapp', 'common']);
          }

        case 1:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, this);
}));